import { useSelector } from "react-redux";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { useAppSelector } from "../../../../../store/hooks/useAppSelector.ts";
import {
  selectFieldGridId,
  selectIsFieldFreezed,
  selectIsGroupedFields,
  selectTabularFreezedColumns,
} from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import SwitchMenuItem from "./SwitchMenuItem.tsx";

interface Props {
  field: ReportField;
  readonly: boolean;
}

const FreezeField = ({ field, readonly }: Props) => {
  const freezedColumns = useSelector(selectTabularFreezedColumns);
  const dispatch = useAppDispatch();
  const gridId = useAppSelector((state) => selectFieldGridId(state, field));
  const isFieldFreezed = useAppSelector((state) => selectIsFieldFreezed(state, field));
  const isGroupedColumn = useAppSelector((state) => selectIsGroupedFields(state, field));
  const unfreezeLabel = isGroupedColumn ? "Unfreeze Grouped Columns" : "Unfreeze Column";
  const freezeLabel = isGroupedColumn ? "Freeze Grouped Columns" : "Freeze Column";

  return (
    <SwitchMenuItem
      caption={isFieldFreezed ? unfreezeLabel : freezeLabel}
      value={isFieldFreezed}
      onClick={() =>
        dispatch(
          fieldsStateActions.setFreezedColumns({
            left: isFieldFreezed ? freezedColumns.filter((c) => c !== gridId) : [...freezedColumns, gridId],
          })
        )
      }
      disabled={readonly}
    />
  );
};

export default FreezeField;
